import { useLocation, useHistory } from 'react-router-dom';
import { useEffect, useCallback } from 'react';
import styles from './drivers-content.module.sass';
import Pagination from 'componets/pagination';
import isEmpty from 'lodash/fp/isEmpty';
import LoadingCard from 'componets/loading-card';
import { SearchSection } from 'componets/search-section';
import { CreateAccountCard } from './create-account-card';
import { DriverAccountList } from './driver-account-list';
import { useEnterpriseDrivers } from '../use-enterprise-drivers';
import analytics from 'service/analytics';

export const DriversContent = ({ isUserAllowedToWriteDriverPage }) => {
  const location = useLocation();
  const history = useHistory();
  const urlSearchParams = new URLSearchParams(location.search);
  const page = urlSearchParams.get('page');
  const search = urlSearchParams.get('search');
  const {
    enterpriseDrivers,
    enterpriseDriversPaging,
    refetchEnterpriseDrivers,
    getEnterpriseDriversStatus,
  } = useEnterpriseDrivers({ page: page ?? 1, mobileCont: search });

  const isSearchSectionShowing = !!search || !isEmpty(enterpriseDrivers) || enterpriseDriversPaging?.totalPage > 1;

  const isCreateAccountCardShowing = isUserAllowedToWriteDriverPage && !search;

  const handleNavigateToPage = page => {
    const newSearchParams = new URLSearchParams(location.search);
    newSearchParams.set('page', page);

    history.push(`${location.pathname}?${newSearchParams.toString()}`);
  };

  const handleSearchButtonClick = useCallback(
    searchQuery => {
      analytics.driverPageSearchButtonClick();
      history.push(`${location.pathname}?search=${searchQuery}`);
    },
    [history, location.pathname]
  );

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'instant',
    });
  }, [page]);

  return (
    <div className={styles['container']}>
      {isSearchSectionShowing && (
        <SearchSection placeholder="搜尋帳號" defaultSearchQuery={search ?? ''} onSubmit={handleSearchButtonClick} />
      )}
      <div className={styles['inner-container']}>
        {isCreateAccountCardShowing && <CreateAccountCard refetchEnterpriseDrivers={refetchEnterpriseDrivers} />}
        {getEnterpriseDriversStatus === 'loading' ? (
          <LoadingCard />
        ) : (
          <DriverAccountList
            accounts={enterpriseDrivers}
            isDeleteAllowed={isUserAllowedToWriteDriverPage}
            refetchEnterpriseDrivers={refetchEnterpriseDrivers}
            onPageSelected={handleNavigateToPage}
          />
        )}
        {enterpriseDriversPaging && (
          <div className={styles['pagination']}>
            <Pagination
              currentPage={enterpriseDriversPaging.currentPage}
              totalPage={enterpriseDriversPaging.totalPage}
              onPageSelected={handleNavigateToPage}
            />
          </div>
        )}
      </div>
    </div>
  );
};
